import { useContext, useEffect } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import * as Layouts from "./Layouts";
import { UserContext } from "./context";
import { initApp, showSpinner } from "./handlers";
import {
  Acta,
  Actas,
  BuscarInfracciones,
  ListadoNotificador,
  Login,
  Management,
  ManagementActividad,
  ManagementPermisos,
  ManagementRoles,
  ManagementRolesPermisos,
  ManagementUsuarios,
  Menu,
  NotFound,
} from "./screens";
// import Acta from "./screens/Actas/Acta";
import PrivateRoute from "./components/PrivateRoute";
import ActasSinBeneficio from "./screens/Actas/ActasSinBeneficio";
import BuscarActa from "./screens/Actas/BuscarActa";
import ActivityLogs from "./screens/ActivityLogs";
import Auditoria from "./screens/Admin/Auditoria";
import MenuAdmin from "./screens/Admin/Menu";
import MonitoreoPersonal from "./screens/Admin/MonitoreoPersonal";
import Camaras from "./screens/Camaras";
import Estadisticas from "./screens/Estadisticas";
import MCD from "./screens/MCD";
import InfraccionesNuevas from "./screens/MCD/InfraccionesNuevas";
import MenuActas from "./screens/MenuActas";
import CredencialesNotificadores from "./screens/Notificador/Credenciales";
import Permissions from "./screens/Permissions";
import RecibosPagos from "./screens/RecibosPagos";
import ReportesNotificadores from "./screens/ReportesNotificadores";
import GestionActas from "./screens/Actas/GestionActas";
import MenuFM from "./screens/MenuFM/MenuFM";
import MenuNotificador from "./screens/Notificador/MenuNotificador/MenuNotificador";
import ActasReparto from "./screens/Notificador/ActasReparto/ActasReparto";
import ActasNotificadas from "./screens/Notificador/ActasNotificadas/ActasNotificadas";
import ActasNoNotificadas from "./screens/Notificador/ActasNoNotificadas/ActasNoNotificadas";
import InfraccionesAnuladas from "./screens/MCD/InfraccionesAnuladas";
import Agentes from "./screens/Admin/Agentes";
import GestionActasAnuladas from "./screens/Actas/GestionActasAnuladas";


const App = () => {
  const { actions, loading } = useContext(UserContext);
  

  useEffect(() => {
    initApp(actions);
  }, []);

  showSpinner(loading);

  return (
    <HashRouter>
      <Routes>
        <Route element={<Layouts.UserLayout />}>
          <Route element={<PrivateRoute role={"admin"} />}>
            {/* <Route element={<PrivateRoute role={"nqnaccesibleadminjp"} />}> */}
            <Route path="/mcd" element={<MCD />} />
            {/* <Route element={<PrivateRoute permission={"nqnaccesible.view.infraccionesnuevas"} />}> */}
            <Route element={<PrivateRoute permission={""} />}>
              <Route path="/mcd/infracciones-nuevas" element={<InfraccionesNuevas />} />
              <Route path="/mcd/infracciones-anuladas" element={<InfraccionesAnuladas />} />
            </Route>
          </Route>

          {/* <Route path="/" element={<Menu />} /> */}
          <Route path="/" element={<MenuFM />} />
          {/* <Route path="/menu-actas" element={<MenuActas />} /> */}

          <Route element={<PrivateRoute permission={"JP"} />}>
            <Route path="/menu-admin" element={<MenuAdmin />} />
            <Route path="/agentes" element={<Agentes />} />
            <Route path="/actas-anuladas" element={<GestionActasAnuladas />} />


            <Route path="/monitoreo" element={<MonitoreoPersonal />} />
            <Route path="/estadisticas" element={<Estadisticas />} />

            <Route element={<PrivateRoute role={"admin"} />}>
              <Route path="/auditoria" element={<Auditoria />} />
              <Route path="/permisos-test" element={<Permissions />} />
            </Route>
            {/* <Route path="/eventos" element={<Eventos />} /> */}
          </Route>

          <Route element={<PrivateRoute role={"admin.app"} />}>
            <Route path="/notificador/credenciales" element={<CredencialesNotificadores />} />
          </Route>

          <Route element={<PrivateRoute permission={"actas.notificar"} />}>
            <Route path="/notificador/listado-actas" element={<ListadoNotificador />} />
            <Route path="/notificador" element={<MenuNotificador />} />
            <Route path="/notificador/reparto" element={<ActasReparto />} />
            <Route path="/notificador/notificadas" element={<ActasNotificadas />} />
            <Route path="/notificador/sin-entregar" element={<ActasNoNotificadas />} />
          </Route>

          <Route element={<PrivateRoute permission={"actas.view.buscar"} />}>
            <Route path="/buscar-acta" element={<BuscarActa />} />
          </Route>

          <Route path="/gestion-actas" element={<GestionActas titulo={"Actas Foto Multa"} />} />

          <Route element={<PrivateRoute permission={"actas.view.notificadas"} />}>
            <Route
              path="/actas-notificadas"
              element={
                <Actas
                  titulo={"Actas notificadas"}
                  pathActas={"actas_notificadas"}
                  estado_id={4}
                  estados={[4]}
                />
              }
            />
          </Route>
          {/* //* Nueva ruta  AGREGAR EL PERMISO actas.view.dobleChequeo*/}
          {/* <Route element={<PrivateRoute permission={"JP"} />}>
            <Route
              path="/actas-doble-chequeo"
              element={
                <Actas
                  titulo={"Actas doble chequeo"}
                  pathActas={"actas_notificadas"}
                  estado_id={17}
                  estados={[17]}
                />
              }
            />
          </Route> */}

          {/* <Route element={<PrivateRoute permission={"actas.view.descargo"} />}>
            <Route
              path="/actas-descargo"
              element={
                <Actas
                  titulo={"Actas en descargo"}
                  pathActas={"actas_descargo"}
                  estado_id={13}
                  estados={[13]}
                />
              }
            />
          </Route> */}

          {/* <Route element={<PrivateRoute permission={"actas.view.tribunales"} />}>
            <Route
              path="/actas-tribunales"
              element={
                <Actas
                  titulo={"Actas tribunales"}
                  pathActas={"actas_tribunales"}
                  estado_id={15}
                  estados={[15]}
                />
              }
            />
          </Route> */}
          {/* 
          <Route element={<PrivateRoute permission={"actas.view.chequear"} />}>
            <Route
              path="/actas-a-chequear"
              element={
                <Actas
                  titulo={"Actas a chequear"}
                  pathActas={"actas_a_chequear"}
                  estado_id={3}
                  estados={[1, 3, 9, 16, 7]}
                />
              }
            />
          </Route> */}

          {/* <Route element={<PrivateRoute permission={"actas.view.incompletas"} />}>
            <Route
              path="/actas_incompletas"
              element={
                <Actas
                  titulo={"Actas con datos domicilio incompleto"}
                  pathActas={"actas_incompletas"}
                  estado_id={7}
                  estados={[7]}
                />
              }
            />
          </Route> */}

          {/* <Route element={<PrivateRoute permission={"actas.view.aprobadas"} />}>
            <Route
              path="/actas"
              element={
                <Actas
                  titulo={"Actas aprobadas para imprimir"}
                  pathActas={"actas_aprobadas"}
                  estado_id={10}
                  estados={[10]}
                />
              }
            />
          </Route> */}

          {/* <Route element={<PrivateRoute permission={"actas.view.asignar"} />}>
            <Route
              path="/actas-a-asignar"
              element={
                <Actas
                  titulo={"Asignar actas a notificador"}
                  pathActas={"actas_a_asignar"}
                  estado_id={2}
                  estados={[2]}
                />
              }
            />
          </Route> */}

          {/* <Route element={<PrivateRoute permission={"actas.view.reparto"} />}>
            <Route
              path="/actas-reparto"
              element={
                <Actas
                  titulo={"Actas en reparto"}
                  pathActas={"actas_reparto"}
                  estado_id={8}
                  estados={[8]}
                />
              }
            />
          </Route> */}

          {/* <Route element={<PrivateRoute permission={"actas.view.anuladas"} />}>
            <Route
              path="/actas-anuladas"
              element={
                <Actas
                  titulo={"Actas anuladas"}
                  pathActas={"actas_anuladas"}
                  estado_id={12}
                  estados={[12]}
                />
              }
            />
          </Route> */}

          {/* <Route element={<PrivateRoute permission={"actas.view.abonadas"} />}>
            <Route
              path="/actas-abonadas"
              element={
                <Actas
                  titulo={"Actas abonadas"}
                  pathActas={"actas_abonadas"}
                  estado_id={11}
                  estados={[11]}
                />
              }
            />
          </Route> */}
          {/* <Route path="/menu" element={<Menu />} /> */}
          <Route element={<PrivateRoute permission={"camaras.view.general"} />}>
            <Route element={<Camaras />} path="/mapa-de-puntos" />
          </Route>

          <Route element={<Management />} path="/administrador/roles-permisos" />
          <Route element={<ManagementRoles />} path="/administrador/roles-permisos/roles" />
          <Route element={<ManagementPermisos />} path="/administrador/roles-permisos/permisos" />
          <Route
            element={<ManagementRolesPermisos />}
            path="/administrador/roles-permisos/role-permisos"
          />
          <Route element={<ManagementActividad />} path="/administrador/activity-log" />
          <Route element={<ManagementUsuarios />} path="/administrador/roles-permisos/usuarios" />

          {/* <Route path="/actas/:id" element={<Acta />} /> */}
          {/* <Route path="/actas-notificadas/:id" element={<Acta />} /> */}

          <Route path="/actividad" element={<ActivityLogs />} />
          <Route path="*" element={<NotFound />} />

          <Route element={<Layouts.UserAdmin />}>
            <Route path="/actas-sin-beneficio" element={<ActasSinBeneficio />} />
            {/* <Route path="/permisos-test" element={<Permissions />} /> */}

            <Route path="/notificador/reportes" element={<ReportesNotificadores />} />
            <Route path="/recibos_pagos" element={<RecibosPagos />} />
            <Route path="/actas-a-chequear/:id" element={<Acta />} />
          </Route>
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/login-notificador" element={<Login />} />
        <Route path="/busqueda-por-dominio" element={<BuscarInfracciones />} />
      </Routes>
    </HashRouter>
  );
};

export default App;
